module.exports = {"513435100":"新市坝镇","513435101":"田坝镇","513435102":"海棠镇","513435103":"吉米镇","513435104":"斯觉镇","513435105":"普昌镇","513435106":"玉田镇","513435107":"乌史大桥镇","513435108":"苏雄镇","513435202":"新茶乡","513435211":"团结乡","513435212":"嘎日乡","513435219":"沙岱乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/513435.json
// module id = 2576
// module chunks = 0